import gql from "graphql-tag";
import { Company } from "../baseTypes";
export default gql`
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      settings {
        hasSelfTests
        defaultSelfTests
      }
      name
      locations(limit: 500) {
        items {
          companyId
          id
          locationId
          name
        }
      }
    }
  }
`;
export interface GetCompanyQuery {
  getCompany: Company | null;
}
